// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Cairn — tiny DOM + label helpers.

const ESC: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/** Escape user/peer-supplied text before it goes into innerHTML. */
export function escapeHtml(s: string): string {
  return String(s).replace(/[&<>"']/g, (c) => ESC[c]);
}

/** Format a duration in ms as M:SS (e.g. 72345 → 1:12). */
export function fmtTime(ms: number): string {
  const t = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(t / 60);
  const s = t % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

/** "1,240 pts" / "0 pts". */
export function scoreLabel(n: number): string {
  return `${n.toLocaleString('en-US')} pts`;
}

/** "3 cairns" / "1 cairn". */
export function cairnLabel(n: number): string {
  return `${n} cairn${n === 1 ? '' : 's'}`;
}

/** The rank ladder label for a rune 0..12 → A 2 3 … 10 J Q K. */
const RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
export function rankLabel(rank: number): string {
  return RANKS[((rank % 13) + 13) % 13];
}
